module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Ha-Id-Ja.3a4f3363.png";